export const siteInfo = {
  name: "樱花动漫社",
  slogan: "把每一部值得看的动画，认真讲给你听",
  domain: "https://zrltu.cn",
  email: "hello@sakura-anime.example",
  intro:
    "樱花动漫社是一个以编辑视角运营的动漫内容平台。我们不做资源搬运，而是把作品讲清楚：它讲了一个什么故事、适合什么心情去看、有哪些容易被忽略的细节。",
  description:
    "樱花动漫社是专注动漫内容的资讯与推荐平台，提供每季新番速递、编辑精选推荐、经典作品盘点、作品解读与观看指南。",
};

export const navItems = [
  { label: "首页", to: "/" },
  { label: "作品库", to: "/works" },
  { label: "资讯专栏", to: "/articles" },
  { label: "编辑精选榜", to: "/ranking" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

export const categories = [
  {
    id: "hot-blood",
    name: "热血冒险",
    desc: "关于成长、信念与不服输的故事。适合想被点燃的时候看。",
    icon: "ri-fire-line",
  },
  {
    id: "youth-heal",
    name: "青春治愈",
    desc: "节奏舒缓、情绪温柔，讲日常里那些说不出口的小心事。",
    icon: "ri-plant-line",
  },
  {
    id: "scifi-mecha",
    name: "科幻机战",
    desc: "从星际远航到巨型机甲，讨论技术与人的边界。",
    icon: "ri-rocket-2-line",
  },
  {
    id: "romance-daily",
    name: "恋爱日常",
    desc: "把喜欢藏进一顿饭、一段路、一句没说出口的话里。",
    icon: "ri-heart-3-line",
  },
  {
    id: "mystery-fantasy",
    name: "悬疑奇幻",
    desc: "在虚构世界里解谜，也顺便看看自己会怎么选。",
    icon: "ri-moon-clear-line",
  },
];

export const articleCategories = [
  { id: "season", name: "新番速递" },
  { id: "craft", name: "制作幕后" },
  { id: "review", name: "作品解析" },
  { id: "guide", name: "观看指南" },
];

export const valueProps = [
  {
    icon: "ri-book-open-line",
    title: "资料扎实",
    desc: "每部作品都整理制作团队、年份、集数与题材标签，方便你快速判断是否对味。",
  },
  {
    icon: "ri-lightbulb-line",
    title: "编辑视角",
    desc: "不堆砌评分与噱头，从叙事结构、节奏与情绪落点出发，讲清楚它为什么值得看。",
  },
  {
    icon: "ri-compass-3-line",
    title: "观看建议",
    desc: "给出适合的观看场景与心态提示，让每一次打开动画都更接近你需要的那一部。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "随季节新番与专题企划持续补充内容，保持作品库与专栏的新鲜度。",
  },
];

export const faqs = [
  {
    q: "樱花动漫社提供在线播放吗？",
    a: "不提供。本站是动漫资讯与推荐平台，内容为作品介绍、编辑推荐、解析与观看指南，帮助你在正版平台上找到并了解作品。",
  },
  {
    q: "作品库里收录了哪些作品？",
    a: "目前以官网编辑整理的原创介绍作品为主，按热血冒险、青春治愈、科幻机战、恋爱日常、悬疑奇幻五个分类归档，每部作品都有独立的详情页。",
  },
  {
    q: "如何快速找到想看的一类作品？",
    a: "进入作品库后，可以在左侧选择分类，或在顶部输入关键词、切换标签筛选，结果会实时更新。",
  },
  {
    q: "资讯专栏多久更新一次？",
    a: "专栏随每季新番节奏更新，同时穿插制作幕后、作品解析与观看指南类长文，具体节奏以当期专题为准。",
  },
  {
    q: "页面上的作品资料从哪里来？",
    a: "资料由编辑根据公开的创作信息整理，用于介绍与讨论。若你发现需要更正的地方，欢迎通过邮箱联系我们。",
  },
  {
    q: "可以把你们的内容用在自己的场合吗？",
    a: "欢迎在注明来源与链接的前提下引用摘要。完整文章与整理资料请勿整段转载，具体可以发邮件和我们沟通。",
  },
];